export default "__VITE_ASSET__CAIzC7Zo__"